import { Controller } from 'stimulus'

// Writing reasons for several changed values at once: the change reasons
// popup (value_change_reasons/_popup) and the phone view's reasons screen
// (mobile/tasks/reasons). Same reason for all fills every empty box (never
// one already typed in), the tally counts what's left, and Show all opens a
// long Was / Now.
export default class extends Controller {
  static targets = ['same', 'input', 'tally']

  connect() {
    this.count()
  }

  fillAll() {
    const text = this.sameTarget.value.trim()
    if (!text) {
      this.sameTarget.focus()
      return
    }
    this.inputTargets.filter(input => !input.value.trim()).forEach((input) => {
      const box = input
      box.value = text
    })
    this.count()
  }

  // Enter in Same reason for all fills the boxes rather than saving.
  sameKeydown(event) {
    if (event.key !== 'Enter') return
    event.preventDefault()
    this.fillAll()
  }

  count() {
    if (!this.hasTallyTarget) return
    const left = this.inputTargets.filter(input => !input.value.trim()).length
    this.tallyTarget.classList.toggle('is-done', left === 0)
    this.tallyTarget.innerHTML = left === 0
      ? '<b>All</b> have a reason'
      : `<b>${left}</b> ${left === 1 ? 'needs' : 'need'} a reason`
  }

  toggle(event) {
    const button = event.currentTarget
    const vals = button.closest('.crp-vals')
    const open = vals.classList.toggle('is-open')
    button.textContent = open ? 'Show less' : 'Show all'
    button.setAttribute('aria-expanded', open ? 'true' : 'false')
  }

  // Nothing typed: say so rather than saving nothing. Stopping the event here
  // keeps rails-ujs (listening on the document) from sending the form.
  submit(event) {
    if (this.inputTargets.some(input => input.value.trim())) return

    event.preventDefault()
    event.stopPropagation()
    if (this.hasTallyTarget) this.tallyTarget.innerHTML = 'Type a reason first, or choose <b>Later</b>.'
    if (this.inputTargets.length) this.inputTargets[0].focus()
  }
}
